import { lazy } from 'react';
import BookingDetailed from '@pages/realtor-app/pages/booking-detailed';
import { decryptUserStorage } from '@reducers/UserSlice';
import { Permissions } from '@utils/constants/permissions';

const Search = lazy(() => import('@pages/realtor-app/pages/search'));
const Offer = lazy(() => import('@pages/realtor-app/pages/offer'));
const Flat = lazy(() => import('@pages/realtor-app/pages/flat'));
const Booking = lazy(() => import('@pages/realtor-app/pages/booking'));
const CRM = lazy(() => import('@pages/realtor-app/pages/crm'));
const Task = lazy(() => import('@pages/realtor-app/pages/task'));
const Lead = lazy(() => import('@pages/realtor-app/pages/lead'));
const Contract = lazy(() => import('@pages/realtor-app/pages/contract'));
const Partners = lazy(() => import('@pages/realtor-app/pages/partners'));

const realtorRoutes = [
  {
    path: '/search',
    component: Search,
    exact: true,
    permission: [Permissions.PERMISSION_REALTOR_PAGE]
  },
  {
    path: '/offer',
    component: Offer,
    exact: true,
    permission: [Permissions.PERMISSION_OFFER]
  },
  {
    path: '/search/:id/:name',
    component: Flat,
    exact: true,
    permission: [Permissions.PERMISSION_REALTOR_BOOKING]
  },
  {
    path: '/booking',
    component: Booking,
    exact: true,
    permission: [Permissions.PERMISSION_REALTOR_BOOKING]
  },
  {
    path: '/booking/:id',
    component: BookingDetailed,
    exact: true,
    permission: [Permissions.PERMISSION_REALTOR_BOOKING]
  },
  {
    path: '/crm',
    component: CRM,
    exact: true,
    permission: [Permissions.PERMISSION_PAGE_CRM]
  },
  {
    path: '/crm/:id/:name',
    component: Lead,
    exact: true,
    permission: [Permissions.PERMISSION_PAGE_CRM]
  },
  {
    path: '/task',
    component: Task,
    exact: true,
    permission: [Permissions.PERMISSION_PAGE_CRM]
  },
  {
    path: '/contract',
    component: Contract,
    exact: true,
    permission: [Permissions.PERMISSION_REALTOR_PAGE]
  },
  {
    path: '/partners',
    component: Partners,
    exact: true,
    permission: [Permissions.PERMISSION_REALTOR_PAGE]
  }
];

export const routes: typeof realtorRoutes = [];

const user = decryptUserStorage;

if (typeof user === 'object' && user) {
  realtorRoutes.forEach(route => {
    if (route.permission) {
      if (user?.role) {
        if (route.permission?.every(p => user.role.permissions.includes(p))) {
          routes.push(route);
        }
      } else if (user?.roleTokens && route.permission?.every(p => user.roleTokens![0]?.role?.permissions.includes(p))) {
        routes.push(route);
      }
    } else {
      routes.push(route);
    }
  });
}
